var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAngleLeft = function SvgAngleLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.592 3 4.57 7.623a.517.517 0 0 0 0 .754L9.592 13",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgAngleLeft as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTYgMTYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik05LjU5MTU1IDNMNC41NzAwNCA3LjYyMzA4QzQuNTE4NTMgNy42NzE0MiA0LjQ3NzQ3IDcuNzI5ODEgNC40NDk0MSA3Ljc5NDY0QzQuNDIxMzQgNy44NTk0NyA0LjQwNjg2IDcuOTI5MzYgNC40MDY4NiA4QzQuNDA2ODYgOC4wNzA2NCA0LjQyMTM0IDguMTQwNTQgNC40NDk0MSA4LjIwNTM2QzQuNDc3NDcgOC4yNzAxOSA0LjUxODUzIDguMzI4NTggNC41NzAwNCA4LjM3NjkyTDkuNTkxNTUgMTMiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";